// extracted by mini-css-extract-plugin
module.exports = {"LoginModalContent_text":"LoginModalContent_LoginModalContent_text__aGHxz"};